import { combineReducers } from 'redux';

import { categories_documents } from './categoriesDocumentsReducer';
import { type_documents } from './typeDocumentsReducer';
import { customers } from './customersReducer';
import { general_concepts } from './generalConceptsReducer';
import { concepts } from './conceptsReducer';
import { categories } from './categoriesReducer';
import { catalogue_type_documents } from './cataloguetypeDocumentsReducer';
import { enterprise } from './enterpriseReducer';
import { bank_fees } from './bankFeeReducer';
import { bank_taxes } from './bankTaxesReducer';
import { user } from './userReducer';
import { isabi_taxes } from './isabiTaxesReducer';
import { concepts_discount } from './conceptsDiscountReducer';
import { payments_budgets } from './paymentsBudgetsReducer';
import { dashboard } from './dashboardReducer';

export default combineReducers({
   categories_documents,
   type_documents,
   customers,
   general_concepts,
   concepts,
   categories,
   catalogue_type_documents,
   enterprise,
   bank_fees,
   bank_taxes,
   user,
   isabi_taxes,
   concepts_discount,
   payments_budgets,
   dashboard
});